import React from "react";
import {motion} from "framer-motion";

function AboutUs() {
  return (
    <section className="py-24  relative xl:mr-0 lg:mr-5 mr-0">
      <div className="w-full max-w-7xl px-4 md:px-5 lg:px-5 mx-auto">
        <div className="w-full justify-start items-center xl:gap-12 gap-10 grid lg:grid-cols-2 grid-cols-1">
          <div className="w-full flex-col justify-center lg:items-start items-center gap-10 inline-flex">
            <div className="w-full flex-col justify-center items-start gap-8 flex">
              <div className="flex-col justify-start lg:items-start items-center gap-4 flex">
                <h6 className="text-gray-400 text-base font-normal leading-relaxed">
                  About Us
                </h6>
                <div className="w-full flex-col justify-start lg:items-start items-center gap-3 flex">
                  <h2 className="text-[#6F48E5] text-4xl font-bold font-manrope leading-normal lg:text-start text-center">
                    The Tale of Our Achievement Story
                  </h2>
                  <p className="text-gray-500 text-base font-normal leading-relaxed lg:text-start text-center">
                  Welcome to HireLanka.com, your trusted platform for booking tour vehicles in Sri Lanka! Whether you're planning a family getaway, a corporate outing, or an unforgettable sightseeing experience, we offer a wide range of buses, vans, and minibuses to suit your travel needs. With our easy-to-use platform, you can quickly check vehicle availability, compare options, and secure your ride—all in just a few clicks. Focused on comfort, safety, and convenience, HireLanka.com ensures a smooth and enjoyable journey for every traveler. Book your next trip in Sri Lanka with us today and experience the best in transportation!
                  </p>
                </div>
              </div>
              <div className="w-full flex-col justify-center items-start gap-6 flex">
                <div className="w-full justify-start items-center gap-8 grid md:grid-cols-2 grid-cols-1">
                  {[
                    {
                      title: "10,000+ Journeys",
                      subtitle: "Empowering Your Travel Experience.",
                    },
                    {
                      title: "500+ Vehicles",
                      subtitle: "Quality and Convenience in Every Ride.",
                    },
                  ].map((item, index) => (
                    <motion.div
                    key={index}
                    whileHover={{
                      scale: 1.1,
                      boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)",
                      transition: { duration: 0.4, ease: "easeInOut" },
                    }}
                    className="w-full h-full p-3.5 rounded-xl border border-gray-200 hover:border-gray-400 flex-col justify-start items-start gap-2.5 inline-flex"
                  >
                    <h4 className="text-gray-900 text-2xl font-bold font-manrope leading-9">
                      {item.title}
                    </h4>
                    <p className="text-gray-500 text-base font-normal leading-relaxed">
                      {item.subtitle}
                    </p>
                  </motion.div>
                  ))}
                </div>
                <div className="w-full h-full justify-start items-center gap-8 grid md:grid-cols-2 grid-cols-1">
                  {[
                    {
                      title: "50+ Awards",
                      subtitle:
                        "Excellence in Mobility Solutions, Service, and Reliability.",
                    },
                    {
                      title: "99% Happy Clients",
                      subtitle: "Reflecting Our Commitment to Service.",
                    },
                  ].map((item, index) => (
                    <motion.div
                      key={index}
                      whileHover={{
                        scale: 1.1,
                        boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)",
                        transition: { duration: 0.2, ease: "easeInOut" },
                      }}
                      className="w-full p-3.5 rounded-xl border border-gray-200 hover:border-gray-400 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-2.5 inline-flex"
                    >
                      <h4 className="text-gray-900 text-2xl font-bold font-manrope leading-9">
                        {item.title}
                      </h4>
                      <p className="text-gray-500 text-base font-normal leading-relaxed">
                        {item.subtitle}
                      </p>
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>
            <button className="sm:w-fit w-full group px-3.5 py-2 bg-indigo-50 hover:bg-indigo-100 rounded-lg shadow transition-all duration-700 ease-in-out flex items-center justify-center">
              <span className="px-1.5 text-indigo-600 text-sm font-medium leading-6 group-hover:-translate-x-0.5 transition-all duration-700 ease-in-out">
                Read More
              </span>
              <svg
                className="group-hover:translate-x-0.5 transition-all duration-700 ease-in-out"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <path
                  d="M6.75265 4.49658L11.2528 8.99677L6.75 13.4996"
                  stroke="#4F46E5"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
          <div className="w-full lg:justify-start justify-center items-start flex">
            <div className="sm:w-[564px] w-full sm:h-[646px] h-full sm:bg-gray-100 rounded-3xl sm:border border-gray-200 relative">
              <img
                className="sm:mt-5 sm:ml-5 w-full h-full rounded-3xl object-cover"
                src="https://pagedone.io/asset/uploads/1717742431.png"
                alt="About Us image"
                width={564}
                height={646}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
